export default "__VITE_ASSET__CMACG$o$__"